<script>
import { ref } from 'vue';
import { xios } from '../forms/tempAxios';
import { Notify, Loading, QSpinnerDots, date } from 'quasar';
import Forms from '../forms/Forms.vue';
import { currentModel } from '../forms/currentModel';
import { useRouter } from 'vue-router/composables';

export default {
  components: {
    Forms
  },
  data() {
    return {
      driverId: null,
      isLoading: false,
      formErrors: [],
      driver: null,
      tripHistory: [],
      tripsLoading: false,
      tripError: null,
      passwordVisible: false,
      confirmPasswordVisible: false,
      originalEncryptedPassword: null,
      validation: {
        submitted: false, // Track if form has been submitted at least once
        rules: {
          required: v => !!v || 'This field is required',
          email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Email must be valid',
          minLength: (v, length) => !v || v.length >= length || `Must be at least ${length} characters`,
          passwordMatch: v => !v || v === currentModel.value.password || 'Passwords must match'
        }
      },
      pagination: {
        rowsPerPage: 10
      },
      tripColumns: [
        { name: 'tripId', label: 'Trip ID', field: 'id', align: 'left' },
        { name: 'date', label: 'Date', field: 'scheduledDate', sortable: true, align: 'left' },
        { name: 'origin', label: 'Origin', field: 'meta.poi.name', align: 'left' },
        { name: 'destination', label: 'Destination', field: 'meta.dropoffPoi.name', align: 'left' },
        { name: 'status', label: 'Status', field: 'status', align: 'left' },
      ],
      basic: function() {
        return [
  {
    is: 'TSeparator',
    label: 'Basic Details',
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'Row',
        ui: [
          {
            is: 'TInput',
            Label: 'First Name',
            model: 'firstName',
                  rules: [v => !this.validation.submitted || !!v || 'First name is required'],
                  required: true,
          },
          {
            is: 'TInput',
            Label: 'Last Name',
            model: 'lastName',
                  rules: [v => !this.validation.submitted || !!v || 'Last name is required'],
                  required: true,
          },
        ],
      },
      {
        is: 'TInput',
        Label: 'Email',
        model: 'email',
              rules: [
                v => !this.validation.submitted || !!v || 'Email is required',
                v => !this.validation.submitted || !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Email must be valid'
              ],
              required: true,
      },
    ],
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: 'Mobile Number',
        model: 'phone',
              rules: [v => !this.validation.submitted || !!v || 'Phone number is required'],
              required: true,
      },
      {
        is: 'TDate',
        Label: 'Date of Birth',
        model: 'dateOfBirth',
        format: 'YYYY-MM-DD',
        locale: { 
          days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'], 
          daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], 
          months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'], 
          monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        }
      },
    ],
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TSelect',
        Label: 'Gender',
        options: ['Male', 'Female'],
        useInput: true,
        icon: 'keyboard_arrow_down',
        model: 'gender',
      },
      {
        is: 'TSelect',
        Label: 'Marital Status',
        options: ['Married', 'Single'],
        useInput: true,
        icon: 'keyboard_arrow_down',
        model: 'meta.maritalStatus',
      },
    ],
  },
  {
    is: 'TSeparator',
    label: 'Registration Info',
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: 'DL Number',
        model: 'licenseNumber',
      },
      {
        is: 'TDate',
        Label: 'DL Expiry',
        model: 'licenseExpiry',
        format: 'YYYY-MM-DD',
        locale: { 
          days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'], 
          daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], 
          months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'], 
          monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        }
      },
    ],
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TSelect',
        Label: 'License Type',
        options: ['E-Full', 'GDL'],
        useInput: true,
        icon: 'keyboard_arrow_down',
        model: 'licenseType',
      },
    ],
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TSelect',
        Label: 'Truck Type',
        options: ['Tail Gate', 'Bonded'],
        useInput: true,
        icon: 'keyboard_arrow_down',
        model: 'truckType',
      },
      {
        is: 'TSelect',
        Label: 'Preferred vehicle',
        options: ['1 Ton Truck', '3 Ton Truck', '5 Ton Truck'],
        useInput: true,
        icon: 'keyboard_arrow_down',
        model: 'preferredVehicle',
      },
    ],
  },
  {
    is: 'TSeparator',
    label: 'Payment Details',
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: 'Account Number',
        model: 'meta.paymentDetails.accountNumber',
      },
      {
        is: 'TInput',
        Label: 'Bank Name',
        model: 'meta.paymentDetails.bankName',
      },
    ],
  },
        ];
      },
      second: function() {
        // Get the current edit mode state
        const isEdit = this.isEditMode;
        const self = this; // Store 'this' reference for use inside ui array
        
        return [
  {
    is: 'TSeparator',
    label: 'Address Details',
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: 'Street',
        model: 'meta.address.street',
      },
      {
        is: 'TInput',
        Label: 'City',
        model: 'meta.address.city',
      },
    ],
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: 'State',
        model: 'meta.address.state',
      },
      {
            is: 'TInput',
            Label: 'Postal Code',
        model: 'meta.address.postalCode',
      },
    ],
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: 'Country',
        model: 'meta.address.country',
      },
    ],
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: 'Emergency Contact Name',
        model: 'meta.emergencyContact.name',
      },
      {
        is: 'TInput',
        Label: 'Emergency Contact No',
        model: 'meta.emergencyContact.phone',
      },
    ],
  },
        {
          is: 'TSeparator',
          label: 'Additional Information',
        },
        {
          is: 'Row',
          ui: [
            {
              is: 'TTextarea',
              Label: 'Notes',
              model: 'meta.notes',
      },
    ],
  },
  {
    is: 'TSeparator',
    label: 'User App Access',
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: 'Username',
        model: 'username',
              rules: [v => !this.validation.submitted || !!v || 'Username is required'],
              required: true,
              disable: isEdit, // Use the local variable for evaluation
      },
      {
        is: 'TSelect',
        Label: 'Status',
        options: [
          { label: 'Active', value: 1 },
          { label: 'Inactive', value: 0 },
          { label: 'Suspended', value: -1 },
        ],
        useInput: true,
        emitValue: true,
        mapOptions: true,
        icon: 'keyboard_arrow_down',
        model: 'status',
      },
    ],
  },
  {
    is: 'Row',
    ui: [
      {
        is: 'TInput',
        Label: isEdit ? 'New Password (leave empty to keep current)' : 'Password',
        model: 'password',
        rules: [
          v => {
            if (isEdit) return true; // In edit mode, password can be empty
            return !self.validation.submitted || !!v || 'Password is required';
          },
          v => {
            if (!v) return true; // Skip length validation if empty
            return !self.validation.submitted || v.length >= 8 || 'Password must be at least 8 characters';
          }
        ],
        required: !isEdit,
      },
      {
        is: 'TInput',
        Label: isEdit ? 'Confirm New Password' : 'Confirm Password',
        model: 'meta.confirmPassword',
        rules: [
          v => {
            if (isEdit && !currentModel.value.password) return true; // In edit mode with empty password
            return !self.validation.submitted || !!v || 'Please confirm password';
          },
          v => {
            if (!v && isEdit) return true; // Skip matching validation if empty in edit mode
            return !self.validation.submitted || v === currentModel.value.password || 'Passwords must match';
          }
        ],
        required: !isEdit,},
    ],
  },
  {
    is: 'TUploads',
    items: [
      { Label: 'Profile Image', model: 'meta.uploads.profileImage' },
      {
        Label: 'Driving License',
        model: 'meta.uploads.drivingLicense',
      },
      { Label: 'Personal ID', model: 'meta.uploads.personalId' },
    ],
    x: 'meta.uploads.extra',
  },
        ];
      }
    };
  },
  computed: {
    isViewMode() {
      const routePath = this.$route.path;
      return routePath.includes('/driver/') && !routePath.includes('/edit') && !routePath.includes('/new');
    },
    isEditMode() {
      // Consider edit mode when route includes '/edit' OR when localStorage has a driver ID
      const routePath = this.$route.path;
      const hasDriverId = !!this.driverId; // Set to true if we have a driver ID loaded
      return routePath.includes('/edit') || hasDriverId;
    },
    isCreateMode() {
      return !this.isEditMode && !this.isViewMode;
    },
    pageTitle() {
      if (this.isViewMode) return 'Driver Details';
      return this.isEditMode ? 'Edit Driver' : 'Create Driver';
    },
    // Make form fields read-only in view mode
    formBasic() {
      if (!this.isViewMode) return this.basic();
      
      return this.basic().map(item => {
        if (item.ui) {
          return {
            ...item,
            ui: item.ui.map(uiItem => {
              if (uiItem.ui) {
                return {
                  ...uiItem,
                  ui: uiItem.ui.map(nestedItem => {
                    return { ...nestedItem, disable: true };
                  })
                };
              }
              return { ...uiItem, disable: true };
            })
          };
        }
        return item;
      });
    },
    formSecond() {
      if (!this.isViewMode) return this.second();
      
      return this.second().map(item => {
        if (item.ui) {
          return {
            ...item,
            ui: item.ui.map(uiItem => {
              if (uiItem.ui) {
                return {
                  ...uiItem,
                  ui: uiItem.ui.map(nestedItem => {
                    return { ...nestedItem, disable: true };
                  })
                };
              }
              return { ...uiItem, disable: true };
            })
          };
        }
        return item;
      });
    },
    getAddressDisplay() {
      const address = currentModel.value.meta && currentModel.value.meta.address;
      if (!address) return 'N/A';
      
      const parts = [];
      if (address.street) parts.push(address.street);
      if (address.city) parts.push(address.city);
      if (address.state) parts.push(address.state);
      if (address.postalCode) parts.push(address.postalCode);
      if (address.country) parts.push(address.country);
      
      return parts.length > 0 ? parts.join(', ') : 'N/A';
    }
  },
  mounted() {
    console.log('Component mounted, checking for driver ID');
    
    // Initialize the form
    this.initializeForm();
    
    // Check if we have a driver ID in localStorage (from DriverList navigation)
    const storedDriverId = localStorage.getItem('currentDriverId');
    if (storedDriverId) {
      console.log('Found driver ID in localStorage:', storedDriverId);
      this.driverId = storedDriverId;
      // Set edit mode flag explicitly
      this.loadDriverData(this.driverId);
      
      // Clear the ID once used
      localStorage.removeItem('currentDriverId');
    
    }
    // If in edit mode or view mode, load driver data from route params
    else if ((this.isEditMode || this.isViewMode) && this.$route.params.id) {
      console.log('Found driver ID in route params:', this.$route.params.id);
      this.driverId = this.$route.params.id;
      this.loadDriverData(this.driverId);
      
      // If in view mode, also fetch trips
      if (this.isViewMode) {
        this.fetchDriverTripHistory(this.driverId);
      }
    } else {
      console.log('No driver ID found, mode:', this.isEditMode ? 'edit' : (this.isViewMode ? 'view' : 'create'));
    }
  },
  methods: {
    async initializeForm() {
      // Reset the form when not in edit mode
      if (!this.isEditMode) {
  currentModel.value = {
          firstName: '',
          lastName: '',
          phone: '',
          email: '',
          username: '',
          password: '',
          dateOfBirth: '',
          gender: '',
          licenseNumber: '',
          licenseExpiry: '',
          licenseType: '',
          truckType: '',
          preferredVehicle: '',
          status: 1,
          clientId: 1,
          
    meta: {
            confirmPassword: '',
      address: {
              street: '',
              city: '',
              state: '',
              postalCode: '',
              country: ''
      },
      emergencyContact: {
              name: '',
              phone: ''
      },
      paymentDetails: {
              accountNumber: '',
              bankName: ''
      },
            bloodType: '',
            notes: '',
      uploads: {
        extra: [],
        profileImage: null,
        drivingLicense: null,
              personalId: null
            }
          }
        };
        this.originalEncryptedPassword = null;
        return;
      }
      
      // In edit mode, reuse fetchDriverTrips to load driver data
      try {
        Loading.show({
          spinner: QSpinnerDots,
          message: 'Loading driver data...'
        });
        
        console.log('Fetching driver data for ID:', this.driverId);
        
        // Use fetchDriverTrips to get driver data
        const response = await this.fetchDriverTrips(this.driverId);
        
        console.log('Driver data response:', response);
        
        if (response && response.data && response.data.success && response.data.data.items && response.data.data.items.length > 0) {
          // Store driver data
          const driverData = response.data.data.items[0];
          console.log('Driver data retrieved:', driverData);
          
          this.originalEncryptedPassword = driverData.password;
          
          // Clear password fields in edit mode - user will enter new password only if they want to change it
          const driverDataForForm = { ...driverData };
          
          // Ensure meta object exists
          if (!driverDataForForm.meta) {
            driverDataForForm.meta = {};
          }
          driverDataForForm.meta.confirmPassword = '';
          
          // Format dates properly
          if (driverDataForForm.dateOfBirth) {
            driverDataForForm.dateOfBirth = this.formatDateForInput(driverDataForForm.dateOfBirth);
          }
          
          if (driverDataForForm.licenseExpiry) {
            driverDataForForm.licenseExpiry = this.formatDateForInput(driverDataForForm.licenseExpiry);
          }
          
          // Update model with a full deep copy to ensure reactivity
          currentModel.value = JSON.parse(JSON.stringify(driverDataForForm));
          console.log('Updated currentModel:', currentModel.value);
          
          // Explicitly call ensureNestedObjects to make sure all required structures exist
          this.ensureNestedObjects();
          
          // Show password notification in edit mode
          setTimeout(() => {
            Notify.create({
              message: 'For security reasons, passwords are not displayed. Leave password fields empty to keep the current password, or enter a new password to change it.',
              color: 'blue-grey',
              timeout: 10000,
              actions: [
                { label: 'Understood', color: 'white' }
              ]
            });
          }, 500);
        } else {
          throw new Error('Driver not found or failed to load driver data');
        }
      } catch (error) {
        console.error('Error loading driver data:', error);
        Notify.create({
          message: error.message || 'Failed to load driver data',
          color: 'negative'
        });
      } finally {
        Loading.hide();
      }
    },
    async loadDriverData(id) {
      if (!id) {
        console.error('loadDriverData called with no ID');
        return;
      }
      
      console.log('loadDriverData called with ID:', id);
      this.driverId = id;
      
      // Initialize form which will load driver data in edit mode
      console.log('Calling initializeForm from loadDriverData with driverId:', this.driverId);
      await this.initializeForm();
      console.log('initializeForm completed');
    },
    async fetchDriverTrips(driverId) {
      if (!driverId) return null;
      
      console.log('fetchDriverTrips called with ID:', driverId);
      this.tripsLoading = true;
      this.tripError = null;
      
      try {
        console.log('Making API request to fetch driver with ID:', driverId);
        const response = await xios.post('api-tms/script-pagination-standard', {
          model: 'Driver',
          filterFields: [
            { field: 'id', operator: 'eq', value: driverId }
          ],
          page: 1,
          itemsPerPage: 1
        });
        
        console.log('API response received:', response);
        
        if (response.data.success) {
          if (this.isViewMode) {
            // Only in view mode, also fetch trip history
            this.tripHistory = response.data.data.items || [];
          }
        } else {
          this.tripError = 'Failed to load driver data.';
          console.error('API returned error:', response.data);
        }
        
        // Return response for reuse in other methods
        return response;
      } catch (error) {
        console.error('Error fetching driver data:', error);
        this.tripError = 'Failed to load driver data.';
        throw error;
      } finally {
        this.tripsLoading = false;
      }
    },
    async fetchDriverTripHistory(driverId) {
      if (!driverId) return;
      
      this.tripsLoading = true;
      this.tripError = null;
      
      try {
        const response = await xios.post('api-tms/script-pagination-standard', {
          model: 'Trip',
          filterFields: [
            { field: 'driverId', operator: 'eq', value: driverId }
          ],
          page: 1,
          itemsPerPage: 10
        });
        
        if (response.data.success) {
          this.tripHistory = response.data.data.items || [];
        } else {
          this.tripError = 'Failed to load trip history.';
        }
      } catch (error) {
        console.error('Error fetching driver trips:', error);
        this.tripError = 'Failed to load trip history.';
      } finally {
        this.tripsLoading = false;
      }
    },
    ensureNestedObjects() {
      if (!currentModel.value.meta) {
        currentModel.value.meta = {};
      }
      
      if (!currentModel.value.meta.address) {
        currentModel.value.meta.address = {
          street: '',
          city: '',
          state: '',
          postalCode: '',
          country: ''
        };
      }
      
      if (!currentModel.value.meta.emergencyContact) {
        currentModel.value.meta.emergencyContact = {
          name: '',
          phone: ''
        };
      }
      
      if (!currentModel.value.meta.paymentDetails) {
        currentModel.value.meta.paymentDetails = {
          accountNumber: '',
          bankName: ''
        };
      }
      
      if (!currentModel.value.meta.uploads) {
        currentModel.value.meta.uploads = {
          extra: [],
          profileImage: null,
          drivingLicense: null,
          personalId: null
        };
      }
      
      if (currentModel.value.meta.bloodType === undefined) {
        currentModel.value.meta.bloodType = '';
      }
      
      if (currentModel.value.meta.notes === undefined) {
        currentModel.value.meta.notes = '';
      }
      
      if (currentModel.value.meta.confirmPassword === undefined) {
        currentModel.value.meta.confirmPassword = '';
      }
    },
    validateForm() {
      this.formErrors = [];
      
      // Check required fields
      const requiredFields = [
        { field: 'firstName', label: 'First Name' },
        { field: 'lastName', label: 'Last Name' },
        { field: 'phone', label: 'Phone' },
        { field: 'email', label: 'Email' },
        { field: 'username', label: 'Username' },
      ];
      
      // Only check password fields if we're not in edit mode or if a new password was entered
      if (!this.isEditMode || (this.isEditMode && currentModel.value.password)) {
        requiredFields.push(
          { field: 'password', label: 'Password' },
          { field: 'meta.confirmPassword', label: 'Confirm Password' }
        );
      }
      
      // Check each required field
      requiredFields.forEach(({ field, label }) => {
        const value = this.getNestedValue(currentModel.value, field);
        if (!value) {
          this.formErrors.push(`${label} is required`);
        }
      });
      
      // Password validation
      if (currentModel.value.password) {
        // Check password length
        if (currentModel.value.password.length < 8) {
          this.formErrors.push('Password must be at least 8 characters');
        }
        
        // Check password match
        if (currentModel.value.password !== this.getNestedValue(currentModel.value, 'meta.confirmPassword')) {
          this.formErrors.push('Passwords do not match');
        }
      }
      
      // Email validation
      if (currentModel.value.email && !this.isValidEmail(currentModel.value.email)) {
        this.formErrors.push('Invalid email format');
      }
      
      // Phone validation
      if (currentModel.value.phone && !this.isValidPhone(currentModel.value.phone)) {
        this.formErrors.push('Invalid phone number format');
      }
      
      return this.formErrors.length === 0;
    },
    async submitForm() {
      // Set validation submitted state to trigger validation rules
      this.validation.submitted = true;
      
      // Ensure nested objects exist
      this.ensureNestedObjects();
      
      // Validate form
      if (!this.validateForm()) {
        Notify.create({
          message: 'Please fix the form errors',
          color: 'negative'
        });
        return;
      }
      
      this.isLoading = true;
      
      try {
        // Prepare data for submission
        const formData = { ...currentModel.value };
        
        // In edit mode, if password is empty, use the original password
        if (this.isEditMode && !formData.password) {
          formData.password = this.originalEncryptedPassword;
        }
        
        // Remove confirm password as it's not needed for API
        if (formData.meta) {
          delete formData.meta.confirmPassword;
          
          // Check if meta contains any nested meta objects and flatten them
          if (formData.meta.meta) {
            // Move all properties from meta.meta to meta
            Object.keys(formData.meta.meta).forEach(key => {
              formData.meta[key] = formData.meta.meta[key];
            });
            
            // Remove the nested meta object
            delete formData.meta.meta;
          }
        }
        
        // Set clientId if not already set
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const clientId = userInfo && userInfo.uid ? userInfo.uid : 1;
        formData.clientId = clientId;
        
        // Prepare API request based on mode
        let requestData;
        let endpoint;
        
        if (this.isEditMode) {
          // Update existing driver
          endpoint = 'api-tms/script-update-standard';
          requestData = {
            model: 'Driver',
            options: {
              id: this.driverId,
              ...formData
            }
          };
        } else {
          // Create new driver
          endpoint = 'api-tms/script-insert-standard';
          requestData = {
            model: 'Driver',
            options: formData
          };
        }
        
        console.log('Submitting data to endpoint:', endpoint);
        console.log('Request data:', requestData);
        
        // Submit data
        const response = await xios.post(endpoint, requestData);
        
        if (response.data.success) {
          Notify.create({
            message: `Driver ${this.isEditMode ? 'updated' : 'created'} successfully`,
            color: 'positive'
          });
          
          // Emit creation success event
          this.$emit('creation-success', 'Driver List');
        } else {
          throw new Error(response.data.message || `Failed to ${this.isEditMode ? 'update' : 'create'} driver`);
        }
      } catch (error) {
        console.error(`Error ${this.isEditMode ? 'updating' : 'creating'} driver:`, error);
        
        // Check for specific API error messages
        const errorMessage = error.response && error.response.data && error.response.data.message || 
                              error.message || 
                              `Failed to ${this.isEditMode ? 'update' : 'create'} driver`;
        
        Notify.create({
          message: errorMessage,
          color: 'negative'
        });
      } finally {
        this.isLoading = false;
      }
    },
    editDriver() {
      this.$router.push(`/driver/${this.driverId}/edit`);
    },
    cancel() {
      // Instead of navigating via router, let's emit an event to change the view
      // to the Driver List, similar to how we handle the redirect after editing
      this.$emit('creation-success', 'Driver List');
      
      // Reset the form state
      this.initializeForm();
      
      // Reset any stored driver ID
      this.driverId = null;
    },
    goBackToDriverList() {
      // Use the same approach as cancel() to return to the Driver List
      this.$emit('creation-success', 'Driver List');
      
      // Reset the form state and driver ID
      this.initializeForm();
      this.driverId = null;
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      try {
        return date.formatDate(dateString, 'MMMM D, YYYY');
      } catch (error) {
        console.error('Error formatting date:', error);
        return dateString || 'N/A';
      }
    },
    getStatusLabel(status) {
      const statusMap = {
        1: 'Active',
        0: 'Inactive',
        '-1': 'Suspended'
      };
      return statusMap[status] || status || 'Unknown';
    },
    getStatusColor(status) {
      const colorMap = {
        1: 'positive',
        0: 'grey',
        '-1': 'negative'
      };
      return colorMap[status] || 'grey';
    },
    getTripStatusLabel(status) {
      const statusMap = {
        'completed': 'Completed',
        'inProgress': 'In Progress',
        'scheduled': 'Scheduled',
        'cancelled': 'Cancelled',
        'unassigned': 'Unassigned',
        'assigned': 'Assigned'
      };
      return statusMap[status] || status || 'Unknown';
    },
    getTripStatusColor(status) {
      const colorMap = {
        'completed': 'positive',
        'inProgress': 'info',
        'scheduled': 'primary',
        'cancelled': 'negative',
        'unassigned': 'grey',
        'assigned': 'green'
      };
      return colorMap[status] || 'grey';
    },
    viewTrip(tripId) {
      this.$router.push({ name: 'trip-view', params: { tripId } });
    },
    getNestedValue(obj, path) {
      return path.split('.').reduce((prev, curr) => {
        return prev && prev[curr] !== undefined ? prev[curr] : null;
      }, obj);
    },
    isValidEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    isValidPhone(phone) {
      // Basic phone validation, can be made more sophisticated
      return /^\+?[0-9\s\-()]{8,}$/.test(phone);
    },
    formatDateForInput(dateString) {
      if (!dateString) return '';
      
      try {
        // Check if it's already in the correct format (YYYY-MM-DD)
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
          return dateString;
        }
        
        // Try parsing the date using the date utility
        return date.formatDate(new Date(dateString), 'YYYY-MM-DD');
      } catch (error) {
        console.error('Error formatting date for input:', error, dateString);
        return dateString;
      }
    },
    togglePasswordVisibility() {
      console.log('Toggle password visibility called, current state:', this.passwordVisible);
      alert('Toggle password visibility called!'); // Debug alert
      this.passwordVisible = !this.passwordVisible;
      console.log('New password visibility state:', this.passwordVisible);
    },
    toggleConfirmPasswordVisibility() {
      console.log('Toggle confirm password visibility called, current state:', this.confirmPasswordVisible);
      alert('Toggle confirm password visibility called!'); // Debug alert
      this.confirmPasswordVisible = !this.confirmPasswordVisible;
      console.log('New confirm password visibility state:', this.confirmPasswordVisible);
    },
  }
};
</script>
<template>
  <div class="fit flex flex-col p-8">
    <!-- Main content -->
    <div class="q-pa-md" v-if="isLoading">
      <div class="flex flex-center q-pa-xl">
        <q-spinner color="primary" size="3em" />
      </div>
    </div>
    
    <template v-else>
      <!-- View Mode -->
      <template v-if="isViewMode">
        <div class="q-pa-md">
          <!-- Page Title -->
          <h4 class="q-my-md text-h5">{{ pageTitle }}</h4>
          
          <div class="row q-col-gutter-md">
            <!-- Driver Info Card -->
            <div class="col-12 col-md-6">
              <q-card class="driver-card">
                <q-card-section class="bg-primary text-white">
                  <div class="text-h6">Driver Information</div>
                </q-card-section>

                <q-card-section>
                  <div class="row items-center q-mb-md">
                    <q-avatar size="72px" color="grey-3" text-color="primary">
                      <q-icon name="person" size="36px" />
                    </q-avatar>
                    <div class="q-ml-md">
                      <div class="text-h5">{{ currentModel.firstName }} {{ currentModel.lastName }}</div>
                      <div class="text-subtitle1">
                        <q-badge :color="getStatusColor(currentModel.status)" text-color="white">
                          {{ getStatusLabel(currentModel.status) }}
                        </q-badge>
                      </div>
                    </div>
                  </div>

                  <div class="q-mb-sm"><span class="text-weight-bold">Phone:</span> {{ currentModel.phone || 'N/A' }}</div>
                  <div class="q-mb-sm"><span class="text-weight-bold">Email:</span> {{ currentModel.email || 'N/A' }}</div>
                  <div class="q-mb-sm"><span class="text-weight-bold">License:</span> {{ currentModel.licenseNumber || 'N/A' }}</div>
                  <div class="q-mb-sm"><span class="text-weight-bold">License Expiry:</span> {{ formatDate(currentModel.licenseExpiry) }}</div>
                  <div class="q-mb-sm"><span class="text-weight-bold">Address:</span> {{ getAddressDisplay() }}</div>
                  <div class="q-mb-sm"><span class="text-weight-bold">Created:</span> {{ formatDate(currentModel.createdAt) }}</div>
                  <div class="q-mb-sm"><span class="text-weight-bold">Last Login:</span> {{ formatDate(currentModel.lastLogin) }}</div>
                </q-card-section>
                
                <q-card-actions align="right">
                  <q-btn flat icon="arrow_back" label="Back to Drivers" color="primary" @click="goBackToDriverList" />
                  <q-btn unelevated label="Edit Driver" icon="edit" color="secondary" @click="editDriver" />
                </q-card-actions>
              </q-card>
            </div>

            <!-- Driver Notes Card -->
            <div class="col-12 col-md-6">
              <q-card class="driver-card">
                <q-card-section class="bg-primary text-white">
                  <div class="text-h6">Notes</div>
                </q-card-section>

                <q-card-section>
                  <div v-if="currentModel.meta && currentModel.meta.notes" class="driver-notes">
                    {{ currentModel.meta.notes }}
                  </div>
                  <div v-else class="text-grey-6 text-center q-pa-md">
                    No notes available for this driver.
                  </div>
                </q-card-section>
              </q-card>
            </div>
          </div>

          <!-- Trip History -->
          <div class="q-mt-md">
            <q-card>
              <q-card-section class="bg-primary text-white">
                <div class="text-h6">Trip History</div>
              </q-card-section>

              <div v-if="tripsLoading" class="flex flex-center q-pa-md">
                <q-spinner color="primary" size="2em" />
              </div>
              
              <div v-else-if="tripError" class="text-center q-pa-md">
                <p class="text-subtitle1 text-negative">{{ tripError }}</p>
                <q-btn color="primary" flat label="Retry" @click="fetchDriverTripHistory(driverId)" />
              </div>
              
              <div v-else>
                <q-table
                  :rows="tripHistory"
                  :columns="tripColumns"
                  row-key="id"
                  :pagination="pagination"
                  :loading="tripsLoading"
                  no-data-label="No trips found for this driver"
                >
                  <template v-slot:body-cell-status="props">
                    <q-td :props="props">
                      <q-badge :color="getTripStatusColor(props.row.status)">
                        {{ getTripStatusLabel(props.row.status) }}
                      </q-badge>
                    </q-td>
                  </template>
                  
                  <template v-slot:body-cell-date="props">
                    <q-td :props="props">
                      {{ formatDate(props.row.scheduledDate) }}
                    </q-td>
                  </template>
                  
                  <template v-slot:body-cell-actions="props">
                    <q-td :props="props">
                      <q-btn flat round size="sm" color="primary" icon="visibility" @click="viewTrip(props.row.id)" />
                    </q-td>
                  </template>
                </q-table>
              </div>
            </q-card>
          </div>
        </div>
      </template>
      
      <!-- Edit and Create Mode -->
      <template v-else>
        <div>
          <!-- Page Title -->
          <h4 class="q-my-md text-h5">{{ pageTitle }}</h4>
          
          <div class="fit flex flex-wrap overflow-auto">
            <div class="bg- w-full lg:w-1/2 flex flex-col gap-4 px-2">
              <Forms :ui="formBasic" />
    </div>
    <div class="bg- w-full lg:w-1/2 flex flex-col gap-4 px-2">
              <Forms :ui="formSecond" />
            </div>
          </div>
      </div>
      </template>
    </template>
    <!-- Button container moved HERE, outside v-else for view mode but inside main template -->
    <!-- Conditionally render buttons only for Create/Edit modes -->
    <div class="q-pa-md q-mt-md row justify-end q-gutter-sm" v-if="!isViewMode">
       <q-btn
        flat
        label="Cancel"
        color="primary"
        @click="cancel"
       />
       <q-btn
        :label="isEditMode ? 'Update Driver' : 'Create Driver'"
        color="primary"
        @click="submitForm"
        :loading="isLoading"
       />
    </div>
  </div>
</template>

<style lang="scss" scoped>
/* Add any custom styles here */
.required-field::after {
  content: "*";
  color: red;
  margin-left: 4px;
}

.driver-card {
  height: 100%;
}

.driver-notes {
  white-space: pre-line;
  min-height: 100px;
}
</style>
